<section
  (click)="clickTracking()"
  class="product-image"
  [class.product-image--cart]="isCartItem"
  [class.product-image--flash]="isFlashOffer"
  [ngClass]="{
    'sustitutes': isSustitutes,
    'card-home': isHome,
    'mini': isMini,
    'detail': isDetail,
    'is-card': isCard,
    'product-image__group': !isUnique,
    'unique': isUnique,
    'scan-and-go': isScanAndGo,
    'item-cart': isCartItem,
    'product-image__home': homeCard,
    'product-image--highlight': highlightCard,
    'product-image--suggest': suggestCard && isHalf
  }"
>
  <div
    [ngStyle]="{'background-image': !isUnique?'url('+mediaImageUrl+')':''}"
    [ngClass]="{
      'background-gray': lazyLoaded,
      'bg-white': internalProduct.mediaImageUrl !== '',
      'product-image__group-wrapper': !isUnique,
      'product-image__group-wrapper--highlight': highlightCard,
      'product-image__group-wrapper--suggest': suggestCard && isHalf,
      'picture-wrapper': isUnique,
      'product-image__group-wrapper--home': !isHome
    }"
  >
    <a
      class="product-image__link"
      [class.product-image__link-group]="!isUnique"
      [attr.data-cuf]="product.id"
      [routerLink]="[href]"
    >
      <div
        class="product-image__offer-band-suggest"
        *ngIf="labelText && !isUnique && isHome"
        [ngClass]="{
          'product-image__offer-band-group-section': !isHome || isUnique,
          'product-image__offer-band-suggest--suggest': suggestCard && isHalf,
          'product-image__offer-band-suggest--highlights': highlightCard
        }"
      >
        <span class="product-image__offer-band-suggest-text" >{{ labelText }}</span>
      </div>

      <picture
        class="cont-img1"
        *ngIf="validateImg()"
      >
        <img
          class="image only-image-show"
          [class.product-image__safari-fix]="browser.safari"
          [class.image--suggest]="isSuggest"
          (click)="algoliaEvent()"
          [src]="mediaImageUrl"
          [alt]="internalProduct.description + ' ' + internalProduct.detailDescription"
        />
      </picture>

      <picture
        *ngIf="(!isMobile ||  !product.listUrlImages) && !validateImg()"
        class="cont-img"
        [class.cont-img__cart-item]="isCartItem"
        [class.cont-img__unique]="isUnique"
      >
        <img 
          #imgChange
          *ngIf="isUnique && lazyLoaded; else isUnique && default"
          (click)="algoliaEvent()"
          class="product-image__image lozad v-none"
          [class.product-image__safari-fix]="browser.safari"
          [attr.data-src]="mediaImageUrl"
          [class.cont-img__image]="isCartItem"
          [class.product-image--flash-offer]="isFlashOffer"
          [class.cont-img__mini]="isMini"
          [alt]="internalProduct.description + ' ' + internalProduct.detailDescription"
        />

        <ng-template #default>
          <img
            class="cont-img__image"
            [class.product-image__safari-fix]="browser.safari"
            (click)="algoliaEvent()"
            [src]="mediaImageUrl"
            [alt]="internalProduct.description + ' ' + internalProduct.detailDescription"
          />
        </ng-template>

        <div
          class="product-image__offer-band"
          *ngIf="shouldShowLabel()"
          [class.product-image__offer-band-section]="!isHome"
          [class.product-image__offer-band-group]="!isHome || isUnique"
          [class.product-image__offer-band-group-section]="!isHome || isUnique"
          [ngStyle]="dynamicStyles"
        >
          <span class="product-image__offer-band-text" >{{ labelText }}</span>
        </div>
      </picture>

      <section
        class="cont-img-dots"
        *ngIf="isMobile && product.listUrlImages?.length > 0 && !validateImg()"
      >
        <div class="cont-image">
          <img
            class="cont-img__image"
            (click)="algoliaEvent()"
            [ngClass]="{
              'cont-img__image--suggest': isSuggest,
              'cont-img__image--suggest-half': isSuggest && isHalf
            }"
            [src]="mediaImageUrl"
            [alt]="internalProduct.description + ' ' + internalProduct.detailDescription"
          />
        </div>
      </section>

      <app-offer-petal
        [showTagOffer]="showTagOffer()"
        [suggestCard]="suggestCard"
        [offerText]="internalProduct?.offerText"
        [description]="internalProduct?.description"
        [detailDescription]="internalProduct?.detailDescription"
        [isMobile]="isMobile"
        [group]="group"
        [showTagOfferPrime]="showTagOfferPrime()"
        [isSuggest]="isSuggest"
        [primeTextDiscount]="internalProduct?.primeTextDiscount"
        [onlyOnline]="internalProduct?.onlyOnline"
      ></app-offer-petal>

      <div
        class="offer-description"
        *ngIf="showOffer()"
        [class.not-available]="checkOfferAvailable()"
        [class.offer-description__new-cards]="!isUnique"
        [class.offer-description--flash]="isFlashOffer"
        [class.offer-description--cart]="isCartItem"
      >
        <p
          class="offer-description__text"
          [class.offer-description__text--flash]="isFlashOffer"
        >
          {{labelText}}
        </p>
      </div>

      <div
        class="offer-description offer-description--prime"
        [class.offer-description--flash]="isFlashOffer"
        [class.offer-description--cart]="isCartItem"
        *ngIf="showOfferDescriptionPrime() && !isSuggest"
        [ngStyle]="offerDescriptionPrimeStyles"
      >
        <p class="offer-description__text">{{internalProduct.primeDescription}}</p>
      </div>

      <div
        class="offer-description custom-tag"
        *ngIf="getCustomTagConfig() && !labelText"
        [ngStyle]="{
          'background-color': customTag?.color,
          'border': 'solid 0.4px ' + customTag?.border
        }"
      >
        <p [ngStyle]="{'color': customTag?.colorText}">{{customTag?.text}}</p>
      </div>
    </a>
  </div>
</section>
